<template>
  <div class="popUpFooter">
    <div class="popUpFooter__box">
      <div class="detailbox">
        <div class="name">
          <p>{{ itemName }}</p>
        </div>
        <span class="price">¥{{ itemPrice }}(税込)</span>
      </div>

      <div class="actionbox">
        <a :href="contentPath">
          <div class="button btn btn-brand-0 u-tx-bold">
            <span class="text">購入へ進む</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pop-up-footer',
  props: {
    itemsId: String,
    itemName: String,
    itemPrice: [Number,String],
    contentPath: { type: String, default: '' }
  }
}
</script>

<style lang="scss">
$container-bg: #ed1e79;
$font-size-base: 10px;
$line-height-computed: 1.2;
$lines-to-show: 2;
$fontFamily: 'Hiragino Kaku Gothic Pro';

.popUpFooter {
  color: #ffffff;
  background: $container-bg;
  font-family: $fontFamily;
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  height: 0px;
  transition: .2s;
  transform: translate3d(0,0,0);
  opacity: 0;
  z-index: 10;
  .app-container--navigation-footer & {
    bottom: 50px;
  }

  p {
    margin: 0;
  }

  &.active {
    height: 72px;
    transition: .3s;
    opacity: 1;
  }

  &__box {
    display: flex;
    max-width: 580px;
    margin: auto;
    height: 100%;
    min-height: 72px;
    width: 100%;
    padding: 0 12px;

    .detailbox {
      width: 100%;
      margin: auto;

      .name {
        display: block;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 1px;
        overflow: hidden;
        width: 100%;
        max-height: $font-size-base * $line-height-computed * $lines-to-show;
        background: $container-bg;

        p {
          word-break: break-all;
          height: auto;
          line-height: $line-height-computed;
          position: relative;

          &:before, &:after {
            background: $container-bg;
            position: absolute;
          }
          &:before {
            content: "…";
            top: $font-size-base * $line-height-computed * ($lines-to-show - 1);
            right: 0;
          }
          &:after {
            content: "";
            height: 100%;
            width: 100%;
          }
        }
      }
      .price {
        display: block;
        font-weight: bold;
        line-height: 14px;
        margin-top: 3px;
      }
    }
    .actionbox {
      padding-left: 8px;
      display: block;
      margin: auto;

      a {
        display: block;
      }

      .button {
        width: 114px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/PopUpFooter.vue